import { useToast } from '@chakra-ui/react';
import generateTransactionHistoryLink from '@Modules/admin/archiving/utils/generateTransactionHistoryLink';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getValidTransactionInquiryDataTableColumns,
  TValidTransactionInquiryDataTableData
} from './ValidTransactionInquiryDataTableMeta';
import ValidTransactionInquiryFilterFormHandler, {
  TValidTransactionInquiryFilterFormData
} from './ValidTransactionInquiryFilterFormHandler';

const ValidTransactionInquiryMixedHandler = () => {
  const [filterFormData, setFilterFormData] =
    React.useState<TValidTransactionInquiryFilterFormData | null>(null);
  const [rowDataTable, setRowDataTable] =
    React.useState<TValidTransactionInquiryDataTableData>({
      primaryKey: '',
      date: '',
      tc: '',
      referenceNumber: '',
      cardNumber: '',
      amount: '',
      mon: '',
      source: '',
    });

  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['ValidTransactionInquiry'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve([{primaryKey: 1}, {primaryKey: 2}, {primaryKey: 3}]), 500);
      });
    },
    refetchInterval: 120000,
    refetchIntervalInBackground: true,
    refetchOnMount: true,
    onSuccess: (data_: any) => {
      //console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { mutateAsync, isLoading: isSubmitting } = useMutation({
    mutationFn: async (rowData: TValidTransactionInquiryDataTableData) => {
      return await new Promise(function (resolve, reject) {
        setTimeout(() => resolve(rowData), 1000);
      });
    },
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    try {
      await mutateAsync(payload);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();

  const handleEdit = (row: any) => {
    setRowDataTable(row.original);
    navigate(generateTransactionHistoryLink(row.original.primaryKey))
  };

  const columns = getValidTransactionInquiryDataTableColumns({
    isLoading,
    handleEdit,
  });

  return (
    <>
      <CC.Accordion defaultIndex={[0]} allowToggle mb={8}>
        <CC.AccordionItem>
          <h2>
            <CC.AccordionButton>
              <CC.Box as="span" flex="1" textAlign="left">
                Filtre et Recherche
              </CC.Box>
              <CC.AccordionIcon />
            </CC.AccordionButton>
          </h2>
          <CC.AccordionPanel pb={4}>
            <ValidTransactionInquiryFilterFormHandler
              setFilterFormData={setFilterFormData}
            />
          </CC.AccordionPanel>
        </CC.AccordionItem>
      </CC.Accordion>

      <CC.Card>
        <CC.CardBody>
          <CustomReactTable data={data || []} columns={columns} />

          <CC.HStack my={6} spacing={6}>
            <CC.Text>Devise</CC.Text>
            <CC.Input type={'text'} w={'40%'} isReadOnly defaultValue={"CFA Franc BEAC"}/>
          </CC.HStack>
        </CC.CardBody>
      </CC.Card>
    </>
  );
};

export default ValidTransactionInquiryMixedHandler;
